import Vue from 'vue';
export class Component extends Vue {
    _tsx;
    $scopedSlots;
}
/**
 * Create component from component options (Compatible with Vue.extend)
 */
export function createComponent(opts) {
    return Vue.extend(opts);
}
const factoryImpl = {
    convert: (c) => c,
    extendFrom: (c) => c,
};
/**
 * Specify Props and Event types of component
 *
 * Usage:
 *  // Get TSX-supported component with props(`name`, `value`) and event(`onInput`)
 *  const NewComponent = tsx.ofType<{ name: string, value: string }, { onInput: string }>.convert(Component);
 */
export function ofType() {
    return factoryImpl;
}
export function withNativeOn(componentType) {
    return componentType;
}
export function withHtmlAttrs(componentType) {
    return componentType;
}
export function withUnknownProps(componentType) {
    return componentType;
}
export function withPropsObject(componentType) {
    return componentType;
}
function createComponentFactory(base, mixins) {
    return {
        create(options) {
            const mergedMixins = options.mixins ? [...options.mixins, ...mixins] : mixins;
            return base.extend({ ...options, mixins: mergedMixins });
        },
        mixin(mixinObject) {
            return createComponentFactory(base, [...mixins, mixinObject]);
        },
    };
}
function createExtendableComponentFactory() {
    return {
        create(options) {
            return Vue.extend(options);
        },
        extendFrom(base) {
            return createComponentFactory(base, []);
        },
        mixin(mixinObject) {
            return createComponentFactory(Vue, [mixinObject]);
        },
    };
}
export const componentFactory = createExtendableComponentFactory();
export function componentFactoryOf() {
    return componentFactory;
}
/**
 * Shorthand of `componentFactory.create`
 */
export const component = componentFactory.create;
export const extendFrom = componentFactory.extendFrom;
export function emit(vm, name, ...args) {
    vm.$emit(name, ...args);
}
export function emitOn(vm, name, ...args) {
    vm.$emit(name.replace(/^on[A-Z]/, v => v[2].toLowerCase()), ...args);
}
export function emitUpdate(vm, name, value) {
    vm.$emit('update:' + name, value);
}
